import React from 'react';
import './RefundPolicyPage.css';
import Products2Hero from '../components/Products2Hero';

const RefundPolicyPage = () => {
  const refundMarquee = [
    'Liberal Cancellation Policy',
    '7-Day Return Window',
    'Certified Quality Check',
    'Fast Refund Processing',
    'Customer First Support',
    'Secure Transaction Returns'
  ];

  const sections = [
    { id: 'sec-1', num: '01', title: 'Cancellation' },
    { id: 'sec-2', num: '02', title: 'Exceptions' },
    { id: 'sec-3', num: '03', title: 'Defective Items' },
    { id: 'sec-4', num: '04', title: 'Expectations' },
    { id: 'sec-5', num: '05', title: 'Refund Process' },
  ];

  return (
    <div className="refund-page">
      <Products2Hero 
        className="hero-tight"
        tagline="NEXAWAVE SUPPORT · FAIRNESS · TRANSPARENT RETURNS"
        title1="Refund Policy"
        title2=""
        title3=""
        description=""
        button1Text="Check Eligibility"
        button1Link="#refund-content"
        button2Text="Terms of Service"
        button2Link="/terms"
        marqueeItems={refundMarquee}
      />
      
      <div id="refund-content" className="refund-content">
        {/* Sticky Sidebar Navigation */}
        <aside className="refund-sidebar">
          <h4 className="sidebar-title">Quick Navigation</h4>
          <ul className="sidebar-nav">
            {sections.map((s) => (
              <li key={s.id}>
                <a href={`#${s.id}`}>
                  <span className="sidebar-nav-num">{s.num}</span>
                  <span>{s.title}</span>
                </a>
              </li>
            ))}
          </ul>
        </aside>

        {/* Main Sections */}
        <div className="refund-sections">
          {/* Cancellation */}
          <section id="sec-1" className="refund-section">
            <h2 className="section-title">Cancellation Policy</h2>
            <p className="section-text">
              NEXAWAVE SOFTWARE SOLUTIONS PRIVATE LIMITED believes in helping its customers as far as possible, and has therefore a liberal cancellation policy.
            </p>
            <p className="section-text">
              Cancellations will be considered only if the request is made within 7 days of placing the order. However, the cancellation request may not be entertained if the orders have been communicated to the vendors/merchants and they have initiated the process of shipping them.
            </p>
          </section>

          {/* Exceptions */}
          <section id="sec-2" className="refund-section">
            <h2 className="section-title">Cancellation Exceptions</h2>
            <p className="section-text">
              NEXAWAVE SOFTWARE SOLUTIONS PRIVATE LIMITED does not accept cancellation requests for perishable items like flowers, eatables etc. However, refund/replacement can be made if the customer establishes that the quality of product delivered is not good.
            </p>
          </section>

          {/* Defective Items */}
          <section id="sec-3" className="refund-section">
            <h2 className="section-title">Damaged or Defective Items</h2>
            <p className="section-text">
              In case of receipt of damaged or defective items please report the same to our Customer Service team. The request will, however, be entertained once the merchant has checked and determined the same at his own end. This should be reported within 7 days of receipt of the products.
            </p>
          </section>

          {/* Expectations */}
          <section id="sec-4" className="refund-section">
            <h2 className="section-title">Customer Expectations</h2>
            <p className="section-text">
              In case you feel that the product received is not as shown on the site or as per your expectations, you must bring it to the notice of our customer service within 7 days of receiving the product.
            </p>
            <p className="section-text">
              In case of complaints regarding products that come with a warranty from manufacturers, please refer the issue to them directly.
            </p>
          </section>

          {/* Refund Process */}
          <section id="sec-5" className="refund-section">
            <h2 className="section-title">Refund Processing</h2>
            <p className="section-text">
              In case of any Refunds approved by the NEXAWAVE SOFTWARE SOLUTIONS PRIVATE LIMITED, it’ll take 6-8 days for the refund to be processed to the end customer.
            </p>
            <div className="disclaimer-box">
              <p>
                <strong>Disclaimer:</strong> The above content is created at NEXAWAVE SOFTWARE SOLUTIONS PRIVATE LIMITED's sole discretion. Razorpay shall not be liable for any content provided here and shall not be responsible for any claims that may arise due to merchant’s non-adherence to it.
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicyPage;